import { cn } from "@/lib/utils";

export function GlassPanel({ children, className, hover, ...props }) {
  return (
    <div
      className={cn(
        "rounded-xl border border-white/10 bg-white/[0.03] backdrop-blur-xl shadow-[0_20px_60px_rgba(0,0,0,0.35)]",
        hover && "glass-hover cursor-pointer",
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}
